import { api } from "./api";

export const checkCep = async (
  cep: string
): Promise<{
  neighborhood: string;
  state: string;
  address: string;
  city: string;
}> => {
  const { data } = await api.get("check-cep/" + cep);
  return data;
};
